<form [formGroup]="formGroupAGB()">
  <br />
  <div class="abschluss_einverstaendnis">
    <h3> {{'registrierung.bedingungen.abschluss_einverstaendnis' | translate}}</h3>
    <div class="flex-container">
      <div style="flex: 12">
        <mat-checkbox formControlName="einverstanden_agb">
          {{ ('registrierung.bedingungen.einverstandnis_intro_' + typ()) | translate }}
          <a [href]="('registrierung.bedingungen.agb_' + typ() + '_url') | translate" target="_blank">{{ ('registrierung.bedingungen.agb_' + typ() + '_text') | translate }}</a> {{ ('registrierung.bedingungen.agb_' + typ() + '_outro') | translate }}
        </mat-checkbox>
      </div>
    </div>
    <div style="flex: 12" class="info-banner info-banner--info">
      <span>{{'registrierung.bedingungen.aareon_speichern_empfohlen' | translate}}</span>
    </div>

  </div>

</form>
